export type { FooterProps } from "./Footer.interface";
export { Footer } from "./Footer";